import React from 'react'

const ValueProposition = () => {
  return (
    <section id="value-prop" className="value-root">
      <div className="container">
        
        <div className="kicker">Why Choose Us</div>

        <h2 className="section-title">
          Why Leading Companies Trust Eleven11 IT Solutions
        </h2>

        <p className="section-sub">
          We combine intelligent automation, modern engineering, and deep technical expertise  
          to deliver solutions that accelerate business growth and reduce operational complexity.
        </p>

        <div className="value-grid">

          <div className="value-card">
            <div className="value-icon">⚡</div>
            <h3>High-Speed Performance</h3>
            <p>
              Optimized systems built to handle heavy workloads with millisecond-level processing.
            </p>
          </div>

          <div className="value-card">
            <div className="value-icon">🔒</div>
            <h3>Enterprise-Grade Security</h3>
            <p>
              End-to-end encryption, secure cloud architecture, and compliance-ready frameworks.
            </p>
          </div>

          <div className="value-card">
            <div className="value-icon">🚀</div>
            <h3>Guaranteed Business Growth</h3>
            <p>
              Clients consistently achieve 3× efficiency and faster scaling within months.
            </p>
          </div>

        </div>
      </div>
    </section>
  );
}

export default ValueProposition;
